import React from 'react'
import styled from 'styled-components'
import { Regular, MqTablet, MqDesktop } from 'streamr-ui/css/consts'
import ScrollEncourager from '~shared/ScrollEncourager'
import Display from '~shared/Display'

const UnstyledAboutUsHero = ({ className }) => (
    <section className={className}>
        <h1 $appear>
            The project&apos;s mission is to replace centralized data brokers with a&nbsp;global,
            decentralized P2P network, addressing the real-time data needs of global media
            broadcasts, and the emerging machine data&nbsp;economy.
        </h1>
        <Display mobile="none" desktop="block">
            <ScrollEncourager center />
        </Display>
    </section>
)

const AboutUsHero = styled(UnstyledAboutUsHero)`
    background-color: white;
    padding: 7.25rem 0 11.25rem;

    h1 {
        font-size: 1.25rem;
        font-weight: ${Regular};
        line-height: 1.6em;
        margin: 0 auto;
        padding: 0 2rem;
    }

    @media ${MqTablet} {
        padding: 5rem 0 9rem;

        h1 {
            font-size: 1.75rem;
            padding: 0;
            text-align: center;
            width: 44rem;
        }
    }

    @media ${MqDesktop} {
        padding: 5rem 0 11rem;

        h1 {
            font-size: 2.6875rem;
            line-height: 1.35em;
            padding: 10.25rem 0;
            width: 65rem;
        }
    }
`

export default AboutUsHero
